import React, { memo, useContext } from 'react'
import { Route, Routes } from "react-router-dom";
import { AuthenticationContext } from '../context/AuthenticationContext'
import { Box } from '@mui/material';
import EventLogReports from '../pages/admin/page/event_log_reports/EventLogReports';
// import MsitMain from '../pages/admin/page/msit/MsitMain';
// import StringInverter from '../pages/admin/page/msit/stringInverter/StringInverter';
import Sld from '../pages/admin/page/Sld/Sld';
import UserDetails from '../pages/admin/page/UserDetails/UserDetails';
import DailyEnergyCurve from '../pages/admin/page/energy_reporting/DailyReportTab/CurveTab/DailyEnergyCurve';
import DailyEnergyLogs from '../pages/admin/page/energy_reporting/DailyReportTab/LogTab/DailyEnergyLogs';
import UserAnalytics from '../pages/admin/page/UserAnalytics/UserAnalytics';
import PlantPowerCurve from '../pages/admin/page/plantPowerCurve/PlantPowerCurve';
import MonthlyReportLog from '../pages/admin/page/energy_reporting/MonthlyReportTab/MonthlyReportLog';
import MonthlyReportCurve from '../pages/admin/page/energy_reporting/MonthlyReportTab/MonthlyReportCurve';
import DashboardTab4 from '../pages/admin/page/dashboard/dashboardTabs/tab4Content/DashboardTab4';
import MaxDemandMis from '../pages/admin/page/Max_DemandMis/MaxDemandMis';
import Sensor from '../pages/admin/page/Sensor/Sensor';
import WeatherDashboard from '../pages/admin/page/WeatherDashboard/WeatherDashboard';
import IncomerFeeder from '../pages/admin/page/IncomerFeeder/IncomerFeeder';
import Incomer from '../pages/admin/page/Switchyard/Incomer/Incomer';
import Outgoing from '../pages/admin/page/Switchyard/Outgoing/Outgoing';
import Spare from '../pages/admin/page/Switchyard/Spare/Spare';
import SensorSwitchyard from '../pages/admin/page/Switchyard/SensorSwitchyard/SensorSwitchyard';
import LoadPattern from '../pages/admin/page/LoadPattern/LoadPattern';

const PrivateRoute = React.lazy(() => import('./stacks/PrivateRoute'))
const Dashboard = React.lazy(() => import('../pages/admin/page/dashboard/Dashboard'))
const Analysis = React.lazy(() => import('../pages/admin/page/analysis/Analysis'))
// const PvMonitoring = React.lazy(() => import('../pages/admin/page/pv_monitoring/PvMonitoring'))
// const WMS = React.lazy(() => import('../pages/admin/page/wms/WMS'))
const PublicRoute = React.lazy(() => import('./stacks/PublicRoute'))
const Login = React.lazy(() => import('../pages/auth/Login'))
const EnergyReporting = React.lazy(() => import('../pages/admin/page/energy_reporting/EnergyReporting'))
// const Inverter = React.lazy(() => import('../pages/admin/page/inverter/Inverter'))
const Inverter1 = React.lazy(() => import('../pages/admin/page/inverter1/Inverter1'))
// const Grid = React.lazy(() => import('../pages/admin/page/grid/Grid'))
// const DG = React.lazy(() => import('../pages/admin/page/dg/DG'))
// const EnergyMeter = React.lazy(() => import('../pages/admin/page/energy_meter/EnergyMeter'))
// const SMB = React.lazy(() => import('../pages/admin/page/smb/SMB'))
const MainRouter = () => {
    const { IsLogged } = useContext(AuthenticationContext);
    return (
        <Routes>
            {
                IsLogged ?
                    <Route path="/" element={<PrivateRoute />}>
                        {/* <Route index element={<WMS/>} /> */}
                        {/* <Route path='dashboard' element={<Dashboard />} /> */}

                        <Route index element={<Dashboard />} />
                        {/* <Route path='inverter' element={<Inverter />} /> */}
                        <Route path='analysis' element={<Analysis />} />


                        <Route path='powerAnalysis' element={<Inverter1 />} />
                        <Route path='userDetail' element={<UserDetails />} />
                        <Route path='monthlyEnergyLog' element={<MonthlyReportLog />} />
                        <Route path='monthlyEnergyCurve' element={<MonthlyReportCurve />} />
                        <Route path='energy-reporting' element={<EnergyReporting />} />
                        <Route path='dailyEnergyCurve' element={<DailyEnergyCurve />} />
                        <Route path='dailyEnergyLog' element={<DailyEnergyLogs />} />
                        <Route path='sld' element={<Sld />} />
                        <Route path='maxDemandMis' element={<MaxDemandMis />} />
                        <Route path='sensor' element={<Sensor />} />
                        <Route path='event-log-reports' element={<EventLogReports />} />
                        <Route path='userAnalytics' element={<UserAnalytics />} />
                        <Route path='plantPowerCurve' element={<PlantPowerCurve />} />
                        <Route path='weather' element={<WeatherDashboard />} />
                        {/* <Route path='incomer' element={<IncomerFeeder />} /> */}
                        <Route path='userdetails' element={<UserDetails/>} />
                        <Route path='incomer' element={<Incomer />} />
                        <Route path='outgoing' element={<Outgoing />} />
                        <Route path='spare' element={<Spare />} />
                        <Route path='sensorSwitchyard' element={<SensorSwitchyard/>} />
                         <Route path='loadPattern' element={<LoadPattern/>} />

                        {/* <Route path="msit" element={<MsitMain />}>
                            <Route index element={<StringInverter />} /> 
                        </Route>; */}

                        <Route path="*" element={<Box>Page Not Found</Box>} />
                    </Route>
                    :
                    <Route path="login" element={<PublicRoute />}>
                        <Route index element={<Login />} />
                        {/* <Route path="services" element={<Services />} />
                       <Route path="about" element={<About />} /> */}
                        <Route path="*" element={<Box>Page Not Found</Box>} />
                    </Route>
            }
        </Routes>


    )
}


export default memo(MainRouter)
